import Vue from 'vue'
import Router from 'vue-router'
import PublicHome from '@/views/public/Home.vue'
import SecureHome from '@/views/secure/Home.vue'
import SecureProjects from '@/views/secure/Projects.vue'
import SecureArticles from '@/views/secure/Articles.vue'
import SecureBlocks from '@/views/secure/Blocks.vue'
import SecurePhrases from '@/views/secure/Phrases.vue'
import Callback from '@/views/Callback.vue'

import {i18n} from "./i18n";



let tmp = navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage || en
const prefered_locale = tmp.split('-')['0']

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/'+prefered_locale+'_'+prefered_locale
    },
    {
      path: '/callback',
      name: 'callback',
      component: Callback
    },
    {
      path: '/:locale(de_de|en_us)',
      name: 'publicHome',
      component: PublicHome
    },
    {
      path: '/:locale(de_de|en_us)/secure',
      name: 'secureHome',
      component: SecureHome
    },
    {
      path: '/:locale(de_de|en_us)/secure/projects',
      name: 'secureProjects',
      component: SecureProjects
    },
    {
      path: '/:locale(de_de|en_us)/secure/articles',
      name: 'secureArticles',
      component: SecureArticles
    },
    {
      path: '/:locale(de_de|en_us)/secure/blocks',
      name: 'secureBlocks',
      component: SecureBlocks
    },
    {
      path: '/:locale(de_de|en_us)/secure/phrases',
      name: 'securePhrases',
      component: SecurePhrases
    },
    {
      path: '*',
      redirect: prefered_locale+'_'+prefered_locale
    },
  ]
})

// very basic "setup" of a global guard
router.beforeEach((to, from, next) => {

  if(to.name == 'callback') { // check if "to"-route is "callback" and allow access
    next()
  } else {

    let locale = to.params.locale;

    if (!locale) {
      locale = prefered_locale
      i18n.locale = locale
    }

    if (to.path.includes('/secure') === false) { //  allow access for public content
      next()
    } else if (router.app.$auth.isAuthenticated()) { // if authenticated allow access for secured content
      next()
    } else { // trigger auth0 login
      router.app.$auth.login()
    }
  }
})

export default router
